import { React, useEffect, useState } from 'react';
import apiService from '../../services/apiServices';
import makeStyles from '@mui/styles/makeStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import TopActions from '../actions/TopActions';
import Fab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { createTheme } from '@mui/material/styles';
import Modal from '../actions/Modal';
import Toast from '../actions/Toasts';
import { Link } from 'react-router-dom';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import { Bars } from 'react-loader-spinner'
import helper from '../../services/helper';

const theme = createTheme({
    palette: {
        primary: {
            light: '#757ce8',
            main: '#3f50b5',
            dark: '#002884',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ff7961',
            main: '#f44336',
            dark: '#ba000d',
            contrastText: '#000',
        },
    },
});

export default function HolidaysList() {
    const [employees, setEmployees] = useState([]);
    const [holidays, setHolidays] = useState([]);
    const [modal, setModal] = useState({});
    const [rowId, setRowId] = useState({});
    const alert = { open: false, message: '', variant: '' };
    const [toast, setToast] = useState(alert);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loader, setLoader] = useState(true);
    const holidayTypes = [{ id: 0, name: "" }, { id: 1, name: "Vjetor" }, { id: 2, name: "Mjekësor" }, { id: 3, name: "Martesor" }, , { id: 4, name: "Pa pagesë" }, { id: 5, name: "Jashtëzakonshëm" }]

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const getEmployees = () => {
        apiService()
            .get('workers')
            .then((response) => {
                if (response.success) {
                    setEmployees(response.data);
                }
            });
    }

    const getHolidays = () => {
        apiService()
            .get('holidays')
            .then((response) => {
                if (response.success) {
                    setLoader(false)
                    setHolidays(response.data);
                }
            });
    }

    useEffect(() => {
        getEmployees();
        getHolidays();
    }, []);

    const handleDelete = (id) => {
        apiService()
            .delete('holidays', id)
            .then((response) => {
                console.log(response)
                if (response) {
                    setModal({ open: false });
                    setToast({
                        open: true,
                        message: 'U fshi me sukses!',
                        variant: 'success',
                    });
                    setHolidays(holidays.filter((holiday) => holiday.Id !== id));
                } else {
                    setModal({ open: false });
                    setToast({
                        open: true,
                        message: 'Ka ndodhur nje gabim!',
                        variant: 'error',
                    });
                }
            });
    };

    const openModal = (id) => {
        setModal({
            open: true,
            tittle: 'Delete',
            message: 'Do you want to delete this row?',
        });
        setToast({ open: false });
        setRowId(id);
    };

    //console.log(workers);
    return (
        <div>
            {loader && <div className="loader-class"><Bars
                height="70"
                width="100%"
                color="#1976d2"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
            /></div>}
            {!loader && <>
                <Modal {...modal} handleDelete={() => handleDelete(rowId)} />
                <Toast {...toast} />
                <TopActions
                    newHref="/holidays/addholiday"
                    saveHref="/dashboard/"
                    saveVisible="d-none"
                />
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Nr</TableCell>
                                <TableCell>Emri</TableCell>
                                <TableCell>Lloji i pushimit</TableCell>
                                <TableCell>Prej</TableCell>
                                <TableCell>Deri</TableCell>
                                <TableCell>Statusi</TableCell>
                                <TableCell>Pershkrimi</TableCell>
                                <TableCell style={{ width: '50px' }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {holidays
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((holiday, index) => (
                                    <TableRow key={holiday.Id}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{holiday.EmployeeName}</TableCell>
                                        <TableCell>{holidayTypes?.find(h => h?.id === holiday.HolidayType)["name"]}</TableCell>
                                        <TableCell>{helper().formatDate(holiday.StartDate)}</TableCell>
                                        <TableCell>{helper().formatDate(holiday.EndDate)}</TableCell>
                                        <TableCell>{holiday.Approve ? "Aprovuar" : "Ne pritje"}</TableCell>
                                        <TableCell>{holiday.Description}</TableCell>
                                        <TableCell>
                                            <ButtonGroup size="small">
                                                <Link to={`holidays/editholiday/${holiday.Id}`}>
                                                    <Button>
                                                        <EditIcon />
                                                    </Button>
                                                </Link>
                                                <Button onClick={() => openModal(holiday.Id)}>
                                                    <DeleteIcon />
                                                </Button>
                                            </ButtonGroup>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={holidays.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </>}
        </div>
    );
}
